
import { computed, defineComponent, onMounted, ref } from 'vue';
import PointInfo from '@/components/organisms/point/PointInfo.vue';
import { useShop } from '@/compositions/useShop';
import { Shop } from '@/repositories/shopRepository';
import { i18n } from '@/plugins/i18n';

type GrantActionType = 'grant' | 'registration_incentive';

export default defineComponent({
  name: 'PointTransferObtain',

  components: {
    PointInfo,
  },

  props: {
    pointTransfer: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    // Set title
    document.title = `付与された${i18n.t('keyword.point')}`;

    const { getDetail } = useShop();

    const shopId = computed(() => {
      const partner: { id: string; type: string } = JSON.parse(props.pointTransfer.purpose).partner;
      return partner.type === 'shop' ? partner.id : null;
    });

    const shop = ref<Shop>();

    const actionType = computed<GrantActionType>(() => {
      return JSON.parse(props.pointTransfer.purpose).action;
    });

    onMounted(async () => {
      if (!shopId.value) return;

      // 店舗詳細取得
      shop.value = await getDetail(shopId.value);
    });

    return {
      shop,
      actionType,
    };
  },
});
